module.exports = __webpack_public_path__ + "media/images/app/products/index/types/necklaces-5eee7c3f59c5e4b3111e3889afd9e5c7.webp";